import React, { ChangeEventHandler, useMemo } from 'react';
import { cx } from 'emotion';
import {
  useEngineInstance,
  useSubjectId
} from '@surveycake/react-logic-engine';
import { useButtonStyles } from 'app/shared/components';
import { useSurveyConfig } from 'app/core/survey-config';
import { useStyles } from './styles';

export interface UploaderProps {
  onChange: ChangeEventHandler<HTMLInputElement>;
}

export default function Uploader({ onChange }: UploaderProps) {
  const engine = useEngineInstance();
  const id = useSubjectId();
  const accept = useMemo(() => {
    const { acceptType } = engine.getSubjectData(id);
    return acceptType ? acceptType.join(',') : undefined;
  }, [engine, id]);
  const { wording } = useSurveyConfig();
  const styles = useStyles();
  const buttonStyles = useButtonStyles(['primary', 'medium']);

  return (
    <div className={cx(buttonStyles.button, styles.trigger)}>
      <input
        className={styles.uploader}
        type="file"
        accept={accept}
        onChange={onChange}
      />
      <span>{wording.subject.fileupload.uploader.button}</span>
    </div>
  );
}
